<template>
    <div class="ui steps">
        <div class="step">
            <div class="content" v-if="!is_can_update">
                <div class="title">{{ core_waybill.sender_company_name || '-' }}</div>
                <div class="title">{{ core_waybill.sender_name || '-' }}</div>
                <p>
                    {{ core_waybill.sender_phone || $t('ui.general.no_data') }}
                </p>
            </div>
            <div class="content" v-else>
                <LabelInputItem
                    v-for="(field_name, index) in ['sender_company_name','sender_name','sender_phone']"
                    style="padding-bottom:6px;"
                    :key="field_name+'card_horizontal_main'"
                    :core_waybill="core_waybill"
                    :field_name="field_name"
                >
                </LabelInputItem>

                <LabelInputItem
                    v-for="(field_name, index) in ['sender_address']"
                    style="padding-bottom:6px;"
                    :is_fluid="true"
                    :key="field_name+'card_horizontal_main'"
                    :core_waybill="core_waybill"
                    :field_name="field_name"
                >
                </LabelInputItem>

                <!-- <RequiredLabel
                    v-if="is_related_columns('sender_address')"
                    :is_required="is_related_columns_is_required('sender_address')"
                    :pointing="'top'">
                </RequiredLabel> -->
            </div>
        </div>
        <div class="active step right aligned">
            <div class="content" v-if="!is_can_update">
                <div class="title">{{ core_waybill.consignee_company_name || '-' }}</div>
                <div class="title">{{ core_waybill.consignee_name || '-' }}</div>
                <p>
                    {{ core_waybill.consignee_phone || $t('ui.general.no_data') }}
                </p>
                <p>
                    {{ core_waybill.consignee_address || $t('ui.general.no_data') }}
                </p>
            </div>
            <div class="content" v-else>
                <LabelInputItem
                    v-for="(field_name, index) in ['consignee_company_name','consignee_name','consignee_phone']"
                    style="padding-bottom:6px;"
                    :key="field_name+'card_horizontal_main'"
                    :core_waybill="core_waybill"
                    :field_name="field_name"
                >
                </LabelInputItem>

                <LabelInputItem
                    v-for="(field_name, index) in ['consignee_address']"
                    style="padding-bottom:6px;"
                    :is_fluid="true"
                    :key="field_name+'card_horizontal_main'"
                    :core_waybill="core_waybill"
                    :field_name="field_name"
                >
                </LabelInputItem>
            </div>
        </div>
    </div>

</template>

<script>
import RequiredLabel from './required_label.vue'
import LabelInputItem from './label_input_item.vue'

export default {
    components: {
        RequiredLabel,
        LabelInputItem
    },
    props: {
        core_waybill: {
            default: {},
            type: Object
        },
        is_can_update: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
        }
    },
    computed: {
    },
    watch: {
        focus_field(ref_name){
            this.$refs[ref_name].focus()
        }
    },
    mounted() {
    },
    methods: {
        is_related_columns(field_name) {
            var result = _.find(this.related_columns, {
                'name': field_name
            });

            if (result) {
                return true
            }
            return false
        },
        is_related_columns_is_required(field_name) {
            var result = _.find(this.related_columns, {
                'name': field_name
            })

            if (result) {
                return result.is_required
            }
            return false
        },
        /*
         * ========================================================================
         * $parent
         * ========================================================================
         */
        is_can_update_field(field_name = "") {
            return this.$parent.is_can_update_field(field_name)
        },
    },
}
</script>

<style lang="scss" scoped>
.ui.segments.core_waybill {
    .ui.steps {
        width: 100%;
        border: 1px #252525 solid;
        border-radius: 0;
        border-right: 0;
        border-left: 0;
        margin: 0;
        overflow-y: hidden;
        overflow-x: auto;
    }
    .ui.steps::-webkit-scrollbar {
        height: 12px;
    }

    .step {
        border-top-left-radius: 0 !important;
        border-top-right-radius: 0 !important;
        justify-content: inherit;
        padding: 12px 6px !important;
    }
    .step .content{
        width: 100%;
    }
    .step p {
        margin-bottom: 3px;
    }
    .step.right.aligned {
        text-align: right;
    }
    .step.right.aligned input {
        text-align: right;
    }
    .active.step, .step.active:after {
        background: #f3f4f5 !important;
        border: 0px solid #f2711c !important
    }
}
</style>
